// A module the account has not activated shows ONE plain page instead of a redirect, a blank page or an API error.
// The sidebar stays usable. Display only - the server refuses the module's endpoints regardless.
import React from "react";
import { Lock } from "lucide-react";
import { isActive, useModules } from "@/lib/modules";

export function ModuleNotActivated() {
  return (
    <div className="p-6 max-w-xl mx-auto" data-testid="module-not-activated">
      <div className="term-panel rounded-md border border-[var(--term-border)] p-6 space-y-2">
        <div className="flex items-center gap-2 text-sm font-bold"><Lock className="h-4 w-4 text-[var(--term-muted)]" />Module not activated</div>
        <div className="text-xs text-[var(--term-secondary)]">This module is not enabled for your account. Please contact your administrator to request access.</div>
      </div>
    </div>
  );
}

/** `module`: a MODULE key (lib/modules). While the answer loads, nothing is shown (no flash of the wrong state). */
export default function ModuleGate({ module, children }) {
  const mods = useModules();
  if (!module) return children;
  if (!mods.loaded) return null;
  return isActive(mods, module) ? children : <ModuleNotActivated />;
}

/** A page the terminal lists but GroundZero does not have yet: says so plainly, with where to go instead. */
export function FeatureUnavailable({ title, text, link, linkText }) {
  return (
    <div className="p-6 max-w-xl mx-auto" data-testid="feature-unavailable">
      <div className="term-panel rounded-md border border-[var(--term-border)] p-6 space-y-2">
        <div className="text-sm font-bold">{title} · not available yet</div>
        <div className="text-xs text-[var(--term-secondary)]">{text}</div>
        {link && <a href={link} className="inline-block text-xs text-[#2563EB] hover:underline">{linkText || "Open"} →</a>}
      </div>
    </div>
  );
}
